module.exports = __webpack_public_path__ + "img/1234.4d2aae29.png";